import { logger as E } from "../../shared-lib/index.js";
import FeatureFlag from "./feature-flag.js";
export function newFeatureFlagFromJson(e) {
  if (e[FeatureFlag.ui.rs] && "boolean" == typeof e[FeatureFlag.ui.Fe]) return new FeatureFlag(e[FeatureFlag.ui.rs], e[FeatureFlag.ui.Fe], e[FeatureFlag.ui.we], e[FeatureFlag.ui.xe]);
  E.info("Unable to create feature flag from ".concat(JSON.stringify(e, null, 2)));
}
export function newFeatureFlagFromSerializedValue(e) {
  if (e[FeatureFlag.ss.rs] && "boolean" == typeof e[FeatureFlag.ss.Fe]) return new FeatureFlag(e[FeatureFlag.ss.rs], e[FeatureFlag.ss.Fe], e[FeatureFlag.ss.we], e[FeatureFlag.ss.xe]);
  E.info("Unable to deserialize feature flag from ".concat(JSON.stringify(e, null, 2)));
}